import React from 'react'
import Page from '../../components/page/Page'
import AirdropOverview from '../../components/airdrops/AirdropOverview'

const Index = () => {
    return (
        <Page
            banners={false}
            id={'AirdropsPage'}
            title="Airdrops to Claim for WUFFI Holders"
            pageTitle="Airdrops to Claim for WUFFI Holders"
            breadcrumbs={[
                {
                    title: 'Home',
                    link: '/',
                },
                {
                    title: 'Airdrops',
                    link: '/airdrops',
                },
            ]}
        >
            <AirdropOverview />
        </Page>
    )
}

export default Index
